module.exports = __webpack_public_path__ + "static/media/9.81997d0a.png";